/**
 * Esc Close
 * ======================================
 * - close popup layers when esc pressed
 */
class EscClose {
	constructor() {
		document.addEventListener('keydown', this.clickHandler, false)
	}

	clickHandler = evt => {
		evt = evt || window.event
		let isEscape = false

		if ('key' in evt) {
			isEscape = evt.key === 'Escape' || evt.key === 'Esc'
		} else {
			isEscape = evt.keyCode === 27
		}

		if (isEscape) {
			const classes = ['sidenav-is-open', 'overlay', 'lock', 'orderform-is-open']
			document.body.classList.remove(...classes)
		}
	}
}

new EscClose()
